var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41867 4.33316V15.9867H1.69318C0.766627 15.9867 0.0078125 15.2439 0.0078125 14.3333V2.48009C0.0078125 0.387403 1.57337 -0.563092 3.48238 0.371429L7.02085 2.12066C7.78766 2.49607 8.41867 3.49448 8.41867 4.33316Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6012 6.20201H2.82953C2.50204 6.20201 2.23047 5.93044 2.23047 5.60296C2.23047 5.27548 2.50204 5.00391 2.82953 5.00391H5.6012C5.92869 5.00391 6.20027 5.27548 6.20027 5.60296C6.20027 5.93044 5.93668 6.20201 5.6012 6.20201Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6012 9.39732H2.82953C2.50204 9.39732 2.23047 9.12575 2.23047 8.79827C2.23047 8.47079 2.50204 8.19922 2.82953 8.19922H5.6012C5.92869 8.19922 6.20027 8.47079 6.20027 8.79827C6.20027 9.12575 5.93668 9.39732 5.6012 9.39732Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0061 10.4345V13.9888C16.0061 15.0911 15.1115 15.9857 14.0092 15.9857H8.41797V6.73633L8.79338 6.8162L12.0203 7.53506L12.4037 7.62292L14.0332 7.99034C14.4246 8.07022 14.784 8.206 15.0955 8.40569C15.0955 8.41367 15.1035 8.41367 15.1035 8.41367C15.1834 8.46958 15.2633 8.53348 15.3352 8.60537C15.7026 8.97279 15.9422 9.50794 15.9981 10.2907C15.9981 10.3386 16.0061 10.3865 16.0061 10.4345Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.c68c9befed9b0e5d04eb164bb3352ec8.svg";
export { ForwardRef as ReactComponent };